import React from 'react';
import IconFromPath from '../IconFromPath/IconFromPath';
import Trapezoid from './Trapezoid';

const TrapezoidIcon = props => (
    <IconFromPath {...props} Path={Trapezoid} />
);

export default TrapezoidIcon;
